import styled from "styled-components";

export const Container = styled.h1`
  color: #444444;
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 3rem;
  text-align: center;
  margin: 4rem 0;
  @media screen and (min-width: 768px) {
  }
`;
